import { useContext, useEffect, useState } from 'react'
import {
  createSearchParams,
  useLocation,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { ConnectorPinsContext } from '../context/context'
import { getRequest, postRequest } from '../../../../../services/base'
import RelatedConnectorsRow from './RelatedConnectorsRow'
import CreateDtcMappingsCheckbox from '../ConnectorPinsSection/CreateDtcMappingsCheckbox'
import Button from '../../../../common/Button'
import { NavContext } from '../../../../../context/global_context'
import ConfirmationPopup from '../../../../common/ConfirmationAlert'

const SelectConnectorSection = () => {
  const [state, dispatch] = useContext(ConnectorPinsContext)
  const [navState, navDispatch] = useContext(NavContext)

  const location = useLocation()
  let { vehicle } = useParams()

  const [searchParams, setSearchParams] = useSearchParams()
  const [relatedConnector, setRelatedConnector] = useState([])
  const [selectedConnectors, setSelectedConnectors] = useState([])
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
  let selected_pins = searchParams.getAll('selected_pins')

  useEffect(() => {
    dispatch({
      type: 'set_pins_filter_data',
      selected_pins:
        state?.selected_pins?.length > 0 ? state?.selected_pins : selected_pins,
      search_old_levels: searchParams.get('search_old_levels')
        ? searchParams.get('search_old_levels')
        : false,
      query_type: searchParams.get('query_type')
        ? searchParams.get('query_type')
        : 'db_level',
      dtc_mapping_type: navState?.destination_only
        ? 'end'
        : searchParams.get('dtc_mapping_type')
          ? searchParams.get('dtc_mapping_type')
          : 'start',
    })
    if (selected_pins?.length > 0) {
      getRelatedConnectors()
    }
  }, [location])

  const getRelatedConnectors = async () => {
    let circuit_ids = [],
      pins = []
    selected_pins.forEach((row, index) => {
      circuit_ids.push(row.split('**$$')[1].split('/'))
      pins.push(row.split('/')[0])
    })
    let res = await getRequest(
      `/api/dtcs/related_connectors/?${createSearchParams({
        circuit_ids: circuit_ids,
        search_old_levels: state?.search_old_levels,
        dtc_mapping_type: state?.dtc_mapping_type,
        connector_name: searchParams.get('connector_name'),
        vehicle_id: vehicle,
        pins: pins,
        is_dtc: true,
      })}`
    )
    if (res?.data?.length > 0) {
      setRelatedConnector(res?.data)
    }
  }

  const onConnectorSelect = (connector_id) => {
    let tmp_rel_connector = [...selectedConnectors]
    if (tmp_rel_connector.includes(connector_id)) {
      tmp_rel_connector = tmp_rel_connector.filter(function (item) {
        return item !== connector_id
      })
    } else {
      tmp_rel_connector.push(connector_id)
    }
    setSelectedConnectors(tmp_rel_connector)
  }

  const createDTCMapping = async () => {
    navDispatch({
      type: 'loader',
      data: { showLoader: true, caption: 'DTC Mapping In Progress' },
      notification: {},
    })
    setShowConfirmationPopup(false)

    let formData = new FormData()
    let dtcIds = searchParams.getAll('dtc_id')
    formData.append('dtc_mapping_type', state?.dtc_mapping_type)
    selectedConnectors.map((connector_id, index) => {
      formData.append('related_connector_ids', connector_id)
    })
    dtcIds.map((dtc_id, index) => {
      formData.append('dtc_id', dtc_id)
    })
    state?.selected_pins.map((pin, index) => {
      let circuit_ids = pin.split('**$$')[1].split('/')
      circuit_ids.map((circuit_id, cr_index) => {
        formData.append('circuit_ids', circuit_id)
      })
    })
    formData.append('create_dtc_circuits', state?.with_circuit_filters)
    formData.append('map_devices', state?.map_devices)
    formData.append('vehicle_id', vehicle)
    formData.append('source_connector', searchParams.get('connector_name'))
    formData.append('is_destination_only', navState?.destination_only)
    let res = await postRequest(`/api/dtcs/create_mapping/`, formData)
    let notification = res?.errors
      .map((notify) => ({
        notification_type: 'error',
        msg: notify,
      }))
      .concat(
        res?.success.map((notify) => ({
          notification_type: 'suceess',
          msg: notify,
        }))
      )
    navDispatch({
      type: 'notification',
      data: notification,
    })
    if (res?.errors?.length < 1 && res?.success?.length < 1) {
      navDispatch({ type: 'loader', data: {}, notification: {} })
    }
    getDtcsDetails()
  }

  const getDtcsDetails = async () => {
    let res = await getRequest(
      `/api/dtcs/mappings/?${createSearchParams({
        dtc_id: searchParams.getAll('dtc_id'),
      })}&vehicle=${vehicle}`
    )
    if (res?.data?.length > 0) {
      let destination_only = false
      if (res?.data?.length > 0) {
        res?.data.forEach((dtcs_obj) => {
          if (dtcs_obj.destination_only) {
            destination_only = true
          }
        })
      }

      navDispatch({
        type: 'header',
        data: {
          dtc_details: res.data,
          destination_only: destination_only,
        },
      })
    }
  }

  return (
    <>
      {!navState?.destination_only && (
        <>
          <h1 className="text-white text-center font-medium text-xl">
            {state?.dtc_mapping_type === 'end'
              ? 'Select Start Connectors'
              : 'Select End Connectors'}
          </h1>
          <div className="flex-auto h-0 overflow-auto">
            {relatedConnector?.map((conn_row, index) => {
              return (
                <RelatedConnectorsRow
                  {...conn_row}
                  key={`related-connector-row-${index}`}
                  onConnectorSelect={(connector_id) => {
                    onConnectorSelect(connector_id)
                  }}
                  selectedConnectors={selectedConnectors}
                />
              )
            })}
          </div>
          {!navState?.destination_only && (
            <CreateDtcMappingsCheckbox
              title={'With Circuit Filters'}
              field={'with_circuit_filters'}
              checked={state?.with_circuit_filters}
              onChange={(e) => {
                dispatch({ type: 'with_circuit_filters', data: e })
              }}
            />
          )}
        </>
      )}

      <CreateDtcMappingsCheckbox
        title={'Map Devices'}
        field={'map_devices'}
        checked={state?.map_devices}
        onChange={(e) => {
          dispatch({ type: 'map_devices', data: e })
        }}
      />

      <Button
        type="submit"
        className={`cursor-pointer btn my-4 w-full`}
        onClick={(e) => setShowConfirmationPopup(true)}
        value={'text'}
        text="Add DTC Mappings"
      />

      {showConfirmationPopup && (
        <ConfirmationPopup
          confirmTitle={
            selectedConnectors?.length > 0 || navState?.destination_only
              ? 'Create DTC Mapping Confirmation'
              : 'Error'
          }
          confirmText={
            selectedConnectors?.length > 0 || navState?.destination_only
              ? 'Click ok to proceed'
              : 'Please select at least on connector'
          }
          onClose={() => {
            setShowConfirmationPopup(false)
          }}
          onConfirm={() => {
            selectedConnectors?.length > 0 || navState?.destination_only
              ? createDTCMapping()
              : setShowConfirmationPopup(false)
          }}
        />
      )}
    </>
  )
}

export default SelectConnectorSection
